export const COMBINED_SEARCH_INITIALIZED = 'COMBINED_SEARCH_INITIALIZED'

export const initializeCombinedSearch = () => {
  return dispatch => {
    dispatch({
      type: COMBINED_SEARCH_INITIALIZED
    })
  }
}
